import { render, staticRenderFns } from "./ItemsModal.vue?vue&type=template&id=4f3283ee&"
import script from "./ItemsModal.vue?vue&type=script&lang=js&"
export * from "./ItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./ItemsModal.vue?vue&type=style&index=0&id=4f3283ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports